/// <reference path="../app.js"/>

$(".large-carousel").each((_index, element) => {
	const carousel = $(element);

	carousel.slick({
		arrows: true,
		dots: true,
		autoplay: true,
		autoplaySpeed: 5000,
		speed: 500
	});

	const dots = carousel.find(".slick-dots > li");

	function updateDots() {
		const active = dots.filter(".slick-active").first();

		if (active.length === 0) return;

		dots.removeAttr("alt-dot");

		active.prev().attr("alt-dot", "1").prev().attr("alt-dot", "2");
		active.next().attr("alt-dot", "1").next().attr("alt-dot", "2");

		for (let i = 0; i < dots.length; i++) {
			if ($(dots[i]).hasClass("slick-active"))
			active.parent().css("transform", `translateX(${i * -24}px)`);
		}

		element.dispatchEvent(new Event("fx-reflow", { bubbles: true }));
	}

	updateDots();

	dots.on("classChanged", () => {
		updateDots();
	});
});